import React, { useState } from "react";

import Stepper from "shared/components/Stepper";
import { TabPanel, TabSwitcher } from "shared/components/Tab";

import Breakdown from "./Breakdown";
import {
  INVOICE,
  REFERENCE_STEPS,
  STEPPER_ITEMS,
  TRANSITION,
  FOLDER,
  PRODUCTS,
  OTHER_PRODUCT,
  PRODUCT_DETAILS,
  INTERVENTION,
  BREAKDOWN,
} from "./constants";
import "./styles.scss";
import Folder from "./Folder";
import Intervention from "./Intervention";
import Invoice from "./Invoice";
import OtherProduct from "./OtherProduct";
import ProductDetails from "./ProductDetails";
import Products from "./Products";
import Transition from "./Transition";

const Component = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [item, setItem] = useState({});

  const onChange = (data, reset) => {
    reset ? setItem({ ...data }) : setItem({ ...item, ...data });
  };

  return (
    <div className={"newfolder--wrapper"}>
      <div className={"newfolder--wrapper--steps"}>
        <Stepper data={STEPPER_ITEMS} activeStep={activeStep} />
      </div>

      <TabSwitcher defaultStep={REFERENCE_STEPS[0]}>
        <TabPanel whenActive={TRANSITION}>
          <Transition setActiveStep={setActiveStep} />
        </TabPanel>
        <TabPanel whenActive={INVOICE}>
          <Invoice setActiveStep={setActiveStep} onChange={onChange} />
        </TabPanel>
        <TabPanel whenActive={FOLDER}>
          <Folder setActiveStep={setActiveStep} onChange={onChange} />
        </TabPanel>
        <TabPanel whenActive={PRODUCTS}>
          <Products setActiveStep={setActiveStep} onChange={onChange} />
        </TabPanel>
        <TabPanel whenActive={OTHER_PRODUCT}>
          <OtherProduct setActiveStep={setActiveStep} onChange={onChange} />
        </TabPanel>
        <TabPanel whenActive={PRODUCT_DETAILS}>
          <ProductDetails
            setActiveStep={setActiveStep}
            item={item}
            onChange={onChange}
          />
        </TabPanel>
        <TabPanel whenActive={INTERVENTION}>
          <Intervention
            setActiveStep={setActiveStep}
            item={item}
            onChange={onChange}
          />
        </TabPanel>
        <TabPanel whenActive={BREAKDOWN}>
          <Breakdown
            setActiveStep={setActiveStep}
            item={item}
            onChange={onChange}
          />
        </TabPanel>
      </TabSwitcher>
    </div>
  );
};

Component.propTypes = {};

export default Component;
